import $http from '@/libs/axios'

export default class IntegrationsAPI {
  static async index(branchId: number) {
    return (await $http.get(`/integrations/list/${branchId}`)).data.data
  }

  static async find(integerId: any, branchId: number, currency = null) {
    return (await $http.get(`/integrations/find/${integerId}/${branchId}?${currency ? `currency=${currency}` : ''}`)).data.data
  }

  static async update(payload: FormData) {
    return (await $http.post('/integrations/update', payload)).data.data
  }

  static async getVendorsIntegrations() {
    return (await $http.get('/integrations/get-vendors-integrations')).data.data
  }
}
